import React from "react";
import {ConfirmationModal} from "../confirmationModal/ConfirmationModal";
import styles from "./UnsavedChangesConfirmationModal.module.css";

interface UnsavedChangesConfirmationModalProps {
    handleCancel: () => void;
    handleContinue: () => void;
    handleClose: (value?: any) => any
}

export const UnsavedChangesConfirmationModal: React.FC<UnsavedChangesConfirmationModalProps> = ({
    handleCancel,
    handleContinue,
    handleClose
}) => {
    const handleConfirm = () => {
        handleContinue();
        handleClose();
    }

    const handleCancelLogic = () => {
        handleCancel();
        handleClose();
    }

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContainer}>
                <ConfirmationModal
                    title={"Unsaved changes"}
                    subtitle={"You have unsaved changes. Are you sure you want to leave this page? Your changes will be lost."}
                    closeButtonTitle={"Cancel"}
                    confirmButtonTitle={"Leave anyway"}
                    onConfirm={handleConfirm}
                    onClose={handleCancelLogic}
                />
            </div>
        </div>
    );
} 
